import * as React from "react";
import { LoadProteinParams, MolstarWrapper, ProteinSelector, renderProtein, SelectPositionProps,ViewerOptionsType } from "@loschmidt/molstar";
import { clientUrlPrefix } from "../../../settings";
import { ll_fetch } from "../../../tools";

interface IProps {
    jobId: string,
    selectedRows: any[],
}

const ViewerOptions: ViewerOptionsType = {
    layoutIsExpanded: false,
    layoutShowControls: false,
    layoutShowRemoteState: false,
    layoutShowSequence: true,
    layoutShowLog: false,
    layoutShowLeftPanel: true,
    layoutShowStructure: true,
  
    viewportShowExpand: true,
    viewportShowControls: true,
    viewportShowSettings: false,
    viewportShowSelectionMode: true,
    viewportShowAnimation: true,
};

type ProteinProps = LoadProteinParams & {
  selector: ProteinSelector;
  // /** The list of ligands assigned to the protein. */
  // ligands: LigandProps[];
  // /** The list of tunnels assigned to the protein. */
  // tunnels: CavityProps[];
  // /** The list of pockets assigned to the protein. */
  // pockets: CavityProps[];
};

interface IState {
  selectedTable: number,
  proteins: ProteinProps[],
  showTable: number,
}

class MolstarComponent extends React.Component<IProps, IState> {

    viewer: MolstarWrapper;
    
    state: IState = {
        selectedTable: 0, //which result table should be displayed   
        proteins: [],
        showTable: 0,
    }

    async initViewer(containerId: string) {
        const pdb = await ll_fetch(`/api/getPDB?jobId=${this.props.jobId}`);
        this.viewer = await MolstarWrapper.init(containerId, ViewerOptions);
        this.viewer.setBackground(0xffffff);
    }

    componentDidMount() {

        this.initViewer("ll-molstar-viewer").then(() => {
            this.loadProtein({ url: clientUrlPrefix + '/api/files/' + this.props.jobId + '/original.pdb', format: 'pdb', label: 'wildType', color: '#FDDA0D' });
        });
    }

  /**
   * Load protein
   * @param props - [[`LoadProteinParams`]]
   */
  async loadProtein(props: LoadProteinParams) {
    const proteinState = this.state.proteins.find(s => s.label === props.label);
    if (proteinState && proteinState.selector) {
      proteinState.selector.show();
    } else {
      const proteinSelector = await renderProtein(this.viewer.plugin, {
        url: props.url,
        format: props.format,
        label: props.label,
        color: props.color
      })

      if (proteinSelector) this.setState({
        proteins: [...this.state.proteins, { ...props, selector: proteinSelector }]
      });
    }
  }


  /**
   * Highlight position in the structure
   * @param proteinLabel
   * @param params
   */
   async selectPosition(proteinLabel: string, params: SelectPositionProps) {
    const proteinState = this.state.proteins.find(
      p => p.label === proteinLabel
    );
    if (proteinState && proteinState.selector) {
      proteinState.selector.selectPosition(params);
    }
  }

  /**
   * Deselect position in the structure.
   * @param proteinLabel
   * @param position
   * @param chain
   * @param tag
   */
  async deselectPosition(
    proteinLabel: string,
    position: number | number[],
    chain: string,
    tag?: string
  ) {
    const proteinState = this.state.proteins.find(
      p => p.label === proteinLabel
    );
    if (proteinState && proteinState.selector) {
      proteinState.selector.deselectPosition(position, chain, tag);
    }
  }

  /**
   * Focus position in the structure.
   * @param proteinLabel
   * @param position
   * @param chain
   */
  async focusPosition(
    proteinLabel: string,
    position: number | number[],
    chain: string
  ) {
    const proteinState = this.state.proteins.find(
      p => p.label === proteinLabel
    );
    if (proteinState && proteinState.selector) {
      proteinState.selector.focusPosition(position, chain);
    }
  }

  getDifference<T>(a: T[], b: T[]): T[] {
    return a.filter((element) => {
      return !b.includes(element);
    });
  }


  componentDidUpdate(prevProps: Readonly<IProps>) {
      if(this.props.selectedRows != null && prevProps.selectedRows != null){

      if (prevProps.selectedRows !== this.props.selectedRows) {
        const toSelect = this.getDifference(this.props.selectedRows, prevProps.selectedRows);
        for (let row of toSelect) {
          this.selectPosition("wildType", {
            position: row.position,
            chain: row.chain,
            color: '#ED1717',
          });
        }
        const toDeselect = this.getDifference(prevProps.selectedRows, this.props.selectedRows);
        for (let row of toDeselect) {
          if (!this.props.selectedRows.some(e => e.position == row.position && e.chain == row.chain)) {
            this.deselectPosition("wildType", row.position, row.chain);
          }
        }
      }
      }
  }


    render() {
            
            return  <div> 
              <div id="ll-molstar-viewer" />              
                    </div>;

    }
}

export default MolstarComponent;
